import { defineComponent as n, openBlock as r, createBlock as c, unref as a, mergeProps as i, withCtx as l, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconGitHubFilled",
  __name: "IconGitHubFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (r(), c(a(m), i(o, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        p("path", { d: "M12 2.247c-5.525 0-10 4.475-10 10a9.99 9.99 0 0 0 6.837 9.487c.5.088.688-.212.688-.475 0-.237-.013-1.025-.013-1.862C7 19.859 6.35 18.784 6.15 18.222c-.113-.288-.6-1.175-1.025-1.413-.35-.187-.85-.65-.013-.662.788-.013 1.35.725 1.538 1.025.9 1.512 2.337 1.087 2.912.825.088-.65.35-1.088.638-1.338-2.225-.25-4.55-1.112-4.55-4.937 0-1.088.387-1.988 1.025-2.688-.1-.25-.45-1.275.1-2.65 0 0 .837-.262 2.75 1.025a9.3 9.3 0 0 1 2.5-.337 9.3 9.3 0 0 1 2.5.337c1.912-1.3 2.75-1.025 2.75-1.025.55 1.375.2 2.4.1 2.65.637.7 1.025 1.588 1.025 2.688 0 3.837-2.337 4.687-4.562 4.937.362.313.675.913.675 1.85 0 1.338-.013 2.413-.013 2.75 0 .263.188.575.688.475A10.02 10.02 0 0 0 22 12.247c0-5.525-4.475-10-10-10" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
